'use strict';

angular.module('formApp').factory('fieldGroupService', [
  '$resource',
  'CONFIG',

  function ($resource, CONFIG) {
    var ownFieldGroupsResource = $resource(CONFIG.OWN_FIELDGROUPS_RESOURCE_URL);
    var fimFieldGroupsResource = $resource(require('../../data/fimFieldGroups.json'));
    var fieldGroupResource = $resource(
      CONFIG.FIELDGROUP_RESOURCE_URL,
      {},
      {
        update: {
          method: 'PUT'
        }
      }
    );

    return {
      getFimFieldGroups: function () {
        return fimFieldGroupsResource.query().$promise;
      },
      getOwnFieldGroups: function () {
        return ownFieldGroupsResource.query().$promise;
      },
      createFieldGroup: function (fieldGroup) {
        return ownFieldGroupsResource.save({}, fieldGroup).$promise;
      },
      updateFieldGroup: function (fieldGroup) {
        return fieldGroupResource.update(
          {
            fieldGroupId: fieldGroup.id
          },
          fieldGroup
        ).$promise;
      },
      removeFieldGroup: function (fieldGroup) {
        return fieldGroupResource.delete(
          {
            fieldGroupId: fieldGroup.id
          },
          fieldGroup
        ).$promise;
      }
    };
  }
]);
